<template>

    <div class="signup-page admin-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row admin-bar">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <div class="row">
                            <div class="col-md-4">
                                <router-link class="next-icon prev-b" to="/admin/artists"><img src="@/assets/img/prev.svg"/> Artist List</router-link>
                            </div>
                            <div class="col-md-4 text-center">
                                <router-link class="next-icon middle-b" :to="`/admin/artist/`+artistId+`/stages/`">Stages List</router-link>
                            </div>
                            <div class="col-md-4">
                                <router-link class="next-icon next-b" :to="`/admin/artist/`+artistId+`/profile/` + profileId">Profile Edit <img src="@/assets/img/next.svg"/></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Edit Artist</h2>
                        <form class="form" v-on:submit.prevent="signupFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-name">Your Name</label>
                                <input type="text" placeholder="Full Name" id="your-name" v-model="name"
                                       v-on:blur="yourName(name)">
                                <p class="error-input" v-if="nameFlag">Full Name is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-email">Your Email</label>
                                <input type="text" placeholder="johndoe@email.com" id="your-email" v-model="email"
                                       v-on:blur="yourEmail(email)">
                                <p class="error-input" v-if="emailFlag">Email address is required</p>
                            </div>
                            <div class="input-select-field form-input">
                                <label for="status">Status * <span></span></label>
                                <select id="status" v-model="status">
                                    <option value="active">Active</option>
                                    <option value="deactivate">Deactivate</option>
                                </select>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-password">Password</label>
                                <input type="password" placeholder="*******" v-model="password" id="your-password">
                            </div>
                            <div class="input-field form-input">
                                <label for="confirm-password">Confirm Password</label>
                                <input type="password" placeholder="*******" v-model="confirmPassword" id="confirm-password">
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SAVE</button>
                                <span v-if="FormSubmited">SAVE...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import axios from 'axios'
    import router from '../../../router'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'ArtistEdit',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        mounted () {
            axios
                .get('/getprofile', {
                    params: {
                        userId: this.artistId
                    }
                })
                .then(response => {
                    this.profileId = response.data.profiles[0]._id
                    this.name = response.data.name
                    this.status = response.data.status
                    this.email = response.data.email
                })
                .catch(error => console.log(error))
        },
        data() {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                nameFlag: false,
                emailFlag: false,
                FormSubmited: false,
                email: '',
                name: '',
                userData: userdata,
                status: '',
                password: 'no change',
                confirmPassword: 'no change',
                profileId: '',
                artistId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            yourName: function (msg) {
                if (!msg) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
            },
            yourEmail: function (msg) {
                if (!msg) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
            },
            signupFormSubmit: function (event) {
                if(this.password == this.confirmPassword){
                    this.FormSubmited = true
                    if(this.email){
                        this.email = this.email.trim().toLowerCase()
                    }
                    try {
                        axios.post('/editArtist', {
                            name: this.name,
                            email: this.email,
                            status: this.status,
                            password: this.password,
                            artistId: this.artistId
                        },{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.FormSubmited = false
                            Vue.$toast.open(
                                {
                                    message: 'Updated Artist!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                        }).catch(err => {
                            this.FormSubmited = false
                            console.log(err)
                        })
                    } catch (e) {
                        this.FormSubmited = false
                        console.log(e)
                    }
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Password mis-smatch',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/artists/Edit.vue